import { Button } from 'antd';
import { APP_PREFIX_PATH } from 'configs/AppConfig';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { changePromotionsQuantity, getStoreTiming } from 'redux/actions';
import { setLocalStorageCart } from 'utils/cart';
import { isOpenByTime } from 'utils/estimated';
import MenuCategories from './menu-categories';
import MenuStaticContent from "./menu-top";

function Menu() {
    const dispatch = useDispatch();
    const {storeData, timings} = useSelector(state => state.fetchedData)
    const {cartQuantity, homePromotion} = useSelector(state => state.cartData)
    const [subTotal, setSubTotal] = useState(0)
    const [promotions, setPromotions] = useState(0)
    const history = useHistory();
    const currency = storeData?.currency?.name ?? 'KWD'

    useEffect(()=>{
        setSubTotal(setLocalStorageCart()?.reduce((acc, cur)=>acc+(cur.itemTotal), 0))
        setPromotions(setLocalStorageCart()?.reduce((acc, cur) => {
            return acc + (cur.product.promotions?.[0]?.discountType === 'AMOUNT' ? cur.product.promotions?.[0].amount :
            cur.product.promotions?.[0]?.discountType === 'PERCENTAGE' ? cur.price * 100 / ( 100 - cur.product.promotions[0].amount) - cur.price : 0) * cur.quantity
        }, 0))
        dispatch(getStoreTiming());
    }, [])

    useEffect(()=>{
        const sumOfItemsPrice = setLocalStorageCart()?.reduce((acc, cur)=>acc+(cur.itemTotal), 0)
        if (homePromotion?.minimumPurchase <= sumOfItemsPrice){
            if (homePromotion?.discountType === 'AMOUNT'){
                setSubTotal(sumOfItemsPrice-homePromotion.amount)
                setPromotions(homePromotion.amount)
            }else{
                setSubTotal(sumOfItemsPrice-(sumOfItemsPrice*homePromotion.amount/100))
                setPromotions(sumOfItemsPrice*homePromotion.amount/100)
            }
        }else{
            setSubTotal(sumOfItemsPrice)
            setPromotions(setLocalStorageCart()?.reduce((acc, cur) => {
                return acc + (cur.product.promotions?.[0]?.discountType === 'AMOUNT' ? cur.product.promotions?.[0].amount :
                cur.product.promotions?.[0]?.discountType === 'PERCENTAGE' ? cur.price * 100 / ( 100 - cur.product.promotions[0].amount) - cur.price : 0) * cur.quantity
            }, 0))
        }
    }, [homePromotion, cartQuantity])

    const reviewCard = () => {
        if (localStorage.getItem('selected-mode') === null || localStorage.getItem('fulfillment-time') === null){// || cartQuantity === 0) {
            history.push(`order-mode?mode=${storeData?.showDeliveryText ? 'delivery' : 'pickup'}`);
            localStorage.setItem('location', 'review-cart');
        } else {
            history.push('review-cart');
        }
    }

    return (
        <>
            <div className='pt-2 px-3 w-100'>
                <MenuStaticContent/>
                <MenuCategories/>
            </div>
            {(cartQuantity>0 && storeData?.enableDelivery) && <div className="menu-bottom">
                <Button className={`w-100 reviewButton`} style={{height:  promotions === 0 ? '48px' : 'auto'}}>
                    <div onClick={reviewCard} className={'cursor-pointer'}>
                        <div className={`w-100 d-flex justify-content-between align-items-center primaryColor`}>
                            <div className="font-16 ml-1 mr-2 d-flex"><div className='reviewButtonNum primaryDarkColor'>{cartQuantity}</div> <span>Review Order</span></div>
                            <div> 
                                {currency} {(subTotal).toFixed(3)} <br/>
                                { promotions !== 0 ? <div style={{textDecoration: 'line-through', fontSize: '13px', filter: 'brightness(40%)'}}>
                                    {currency} {(subTotal + promotions).toFixed(3)}
                                </div> : ""}
                            </div>
                        </div>
                    </div>
                </Button>
            </div>}
            {(!storeData?.enableDelivery || !isOpenByTime(timings)) && <div className='menu-bottom'>
                <Button disabled className={`primaryColor w-100 reviewButton `} style={{height: '48px' }}>
                    <div className={'cursor-pointer'}>
                        <div className={` w-100 d-flex justify-content-center align-items-center`}>
                            Sorry! we're temporarily closed
                        </div>
                    </div>
                </Button>
            </div>}
        </>
    );
}

export default Menu;